<template>
    <div class="container">
        <div class="row flipbook-thumbs">
            <div class='col-12 mb-4 text-center'>
                <h5>Click on a <span class="text-highlight">Grade</span> to See a <span class="text-highlight">PREVIEW</span></h5>
            </div>

<!--            TODO: divide to an good display across 1/2 rows-->
            <div v-if="block.books.length > 1" v-for="(book, i) in block.books" :key="`books_${i}`" class="d-inline-block text-center col-lg-4 mb-lg-0 mb-3 col-4">
                <h4 v-html="book.label"></h4>
                <a @click.prevent="switchBook(i)"><img :src="book.image" alt="flipbook image" class="img-fluid w-100 mb-2" style="border-radius: 4px;"></a>

            </div>
        </div>


        <div style="margin-bottom:20px; text-align: center;">
            <div v-for="(book, i) in block.books" :key="`flipbook_${i}`" ref="flipbooks">
                <div v-show="selectedBook == i" :id="`book_${i}`">
                    <a :href="`https://online.flippingbook.com/view/${book.id}/`" class="fbo-embed" :data-fbo-id="book.id" data-fbo-lightbox="yes" data-fbo-width="900px" data-fbo-height="480px" data-fbo-version="1" style="max-width: 100%">{{book.label}}</a>
                </div>
            </div>
        </div>
        <div id="scroll_to"></div>
    </div>
</template>

<script>
const FLIPBOOK_URL = 'https://online.flippingbook.com/EmbedScriptUrl.aspx?m=redir&hid=';
export default {
    name: "FlipBookView",
    props: ['block'],
    data: () => ({
        selectedBook: 0,
    }),
    methods: {
        switchBook(i) {
            this.selectedBook = i;
            document.getElementById('scroll_to').scrollIntoView(false);
        }
    },
    mounted() {
        for (let i = 0; i < this.block.books.length; ++i) {
            let $script = document.createElement('script');
            $script.setAttribute('src', FLIPBOOK_URL + this.block.books[i].id)
            this.$refs.flipbooks[i].appendChild($script);
        }
    }
}
</script>

<style scoped>
.flipbook-thumbs div img:hover {
    cursor: pointer;
}
</style>